<template>
  <q-card flat bordered class="q-pa-xs">
    <div class="text-h6 q-py-xs" :class="$q.dark.mode ? '' : 'text-primary'">
      Live Bulk Tnx with Market Option
      <div class="text-caption text-bold q-pa-xs">
        As of : {{ convertDateAsOf(selectedDate) }}
      </div>
    </div>
    <!-- start of if -->
    <PackageAuth>
      <template #authorized-content>
        <div class="row">
          <div class="q-gutter-sm">
            <q-radio
              keep-color
              dense
              v-model="filterBulkBuySell"
              val="show_all"
              label="Show All"
              color="primary"
            >
              <q-tooltip>Show All</q-tooltip>
            </q-radio>

            <q-radio
              keep-color
              dense
              v-model="filterBulkBuySell"
              val="bulk_tnx_with_buy"
              label="Bulk Tnx Buy"
              color="teal"
            >
              <q-tooltip>Bulk Tnx with Buy</q-tooltip>
            </q-radio>

            <q-radio
              keep-color
              dense
              v-model="filterBulkBuySell"
              val="bulk_tnx_with_sell"
              label="Bulk Tnx Sell"
              color="red"
            >
              <q-tooltip>Bulk Tnx with Sell</q-tooltip>
            </q-radio>

            <q-checkbox
              dense
              class="q-pl-sm ellipsis"
              v-model="mySignals"
              color="blue-5"
              keep-color
              label="My Signals"
            >
              <q-tooltip class="bg-primary">My Signals Only</q-tooltip>
            </q-checkbox>
          </div>
        </div>

        <div class="row q-pt-md">
          <q-input
            outlined
            dense
            v-model="selectedDate"
            capslock
            mask="date"
            :rules="['date']"
            class="text-bold"
          >
            <q-popup-proxy
              ref="qDateProxy"
              transition-show="scale"
              transition-hide="scale"
            >
              <q-date
                v-model="selectedDate"
                @input="() => $refs.qDateProxy.hide()"
                @update:model-value="loadLiveData(selectedDate)"
              />
            </q-popup-proxy>
            <q-icon
              name="event"
              class="text-grey text-h6 date-icon cursor-pointer q-pt-md"
            />
          </q-input>
        </div>

        <q-table
          flat
          dense
          bordered
          :rows="computedBulkTransactionData"
          :columns="computedColumns"
          :pagination="pagination"
          separator="cell"
          binary-state-sort
          :filter="filterQuery"
          :filter-method="(rows) => filterBulkData(rows, filterQuery)"
          :class="
            $q.dark.mode === true
              ? 'table-sticky-header-column-dark'
              : 'table-sticky-header-column'
          "
        >
          <template v-slot:top-left>
            <div>
              <q-select
                outline
                v-model="selectedSector"
                :options="optionSectors"
                dense
                label="Choose sector"
                single
                input-debounce="0"
                option-label="name"
                option-value="symbol"
                class="ellipsis q-mr-sm"
                :menu-absolute="true"
                style="width: 150px"
              />
              <StockSearch
                :allStocks="allStocks"
                @emitededSymbol="
                  (eSymbol) => {
                    filterSymbol = eSymbol;
                  }
                "
                style="width: 150px"
              />
            </div>
            <div>
              <BrokerSearch
                :filterName="'Filter Buyer'"
                @emitedeBroker="
                  (eBuyer) => {
                    filterBuyer = eBuyer;
                  }
                "
              />
              <BrokerSearch
                :filterName="'Filter Seller'"
                @emitedeBroker="
                  (eSeller) => {
                    filterSeller = eSeller;
                  }
                "
              />
            </div>
            <div>
              <q-select
                v-if="isUserPlatinum"
                outline
                v-model="strength"
                :options="[
                  'All',
                  'Normal',
                  'Strong',
                  'Very Strong',
                  'Very Very Strong',
                ]"
                dense
                label="Strength"
                single
                class="q-mx-sm"
                style="width: 100px"
                :menu-absolute="true"
              />
              <q-select
                v-if="isUserStaff"
                outline
                v-model="percentageChange"
                :options="[
                  'All',
                  '< -5',
                  '-5 < -3',
                  '-3 < -1',
                  '-1 < 0',
                  '0 < 1',
                  '1 < 3',
                  '3 < 5',
                  '> 5',
                ]"
                dense
                label="Percentage Change"
                single
                class="q-mx-sm"
                style="width: 100px"
                :menu-absolute="true"
              />
            </div>
            <div>
              <q-select
                dense
                outlined
                bottom-slots
                v-model="selectedMoreThan"
                :options="optionsMoreThan"
                label="Select No. of Bulk Tnx"
                style="width: 150px"
                class="q-my-sm"
              >
                <template v-slot:hint>
                  <span class="text-body text-bol">
                    No. of Bulk Tnx ≥ {{ selectedMoreThan }}
                  </span>
                </template>
              </q-select>
            </div>
          </template>

          <template v-slot:body-cell-symbol="props">
            <q-td
              :props="props"
              :class="
                props.row.bulk_status === 'BUY'
                  ? 'bg-green-5 text-white'
                  : props.row.bulk_status === 'SELL'
                  ? 'bg-red-5 text-white'
                  : props.row.bulk_status === 'NEUTRAL'
                  ? 'bg-blue-5 text-white'
                  : 'bg-blue-5 text-white'
              "
            >
              <q-item dense clickable @click="onClickSymbolEmit(props.value)">
                <div class="col">
                  {{ props.value }}
                  <q-tooltip>{{
                    allStocks.find((stock) => stock.symbol == props.value)?.name
                  }}</q-tooltip>
                </div>
              </q-item>
            </q-td>
          </template>

          <template v-slot:body-cell="props">
            <q-td
              :props="props"
              :class="
                props.row.bulk_status === 'BUY'
                  ? 'bg-green-5 text-white'
                  : props.row.bulk_status === 'SELL'
                  ? 'bg-red-5 text-white'
                  : props.row.bulk_status === 'NEUTRAL'
                  ? 'bg-blue-5 text-white'
                  : 'bg-blue-5 text-white'
              "
            >
              {{ props.value }}
            </q-td>
          </template>
        </q-table>
      </template>
    </PackageAuth>
    <!-- end of inner else -->

    <!-- end of else -->
  </q-card>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue";

import useData from "src/use/data";
import { useStore } from "vuex";
import useUtils from "src/use/utils";

import moment from "moment";
import { useQuasar, LocalStorage } from "quasar";
import PackageAuth from "src/components/Packages/PackageAuth.vue";
import StockSearch from "src/components/StockProfile/StockSearch";
import BrokerSearch from "src/components/StockProfile/BrokerSearch";

const emit = defineEmits(["chartSymbol"]);

const store = useStore();
const $q = useQuasar();
const {
  BulkTransactionWithMarketBuySellWithDate,
  BulkTransactionWithMarketBuySell,
} = useData();
const { amountConversion, filterBulkData, utilsOptionSectors } = useUtils();

const filterSymbol = ref("");
const filterBuyer = ref("");
const filterSeller = ref("");
const strength = ref("All");
const percentageChange = ref("All");
const isUserPlatinum = ref(false);
const isUserStaff = ref(false);
let interval;

const isMarketOn = ref(false);
isMarketOn.value = LocalStorage.getItem("isMarketOn");
const selectedDate = ref("");
const asOfLiveDate = ref("");
const mySignals = ref(false);

const allStocks = ref([]);
const mySignalsStocks = ref([]);
const bulkTransactionData = ref([]);

const filterBulkBuySell = ref("show_all");

const optionSectors = ref(utilsOptionSectors());
const selectedSector = ref(optionSectors.value[0]);

const optionsMoreThan = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const selectedMoreThan = ref(optionsMoreThan[0]);

const filterQuery = computed({
  get() {
    return {
      symbol: filterSymbol.value?.toLowerCase(),
      buyer: filterBuyer.value?.toLowerCase(),
      seller: filterSeller.value?.toLowerCase(),
    };
  },
  set(newValue) {
    filterSymbol.value = newValue.symbol;
    filterBuyer.value = newValue.buyer;
    filterSeller.value = newValue.seller;
  },
});

function parseRange(str) {
  // Remove any extra spaces and symbols
  const cleanedStr = str.trim();

  // Handle open-ended ranges and specific ranges
  let start = -Infinity;
  let end = Infinity;

  if (cleanedStr[0] === "<") {
    end = parseInt(cleanedStr.slice(1), 10);
  } else if (cleanedStr[0] === ">") {
    start = parseInt(cleanedStr.slice(1), 10);
  } else {
    // Split by '<' and handle range values
    const [startPart, endPart] = cleanedStr.split("<");
    start = parseInt(startPart.trim(), 10);
    end = parseInt(endPart.trim(), 10);
  }

  return { start, end };
}

const groupDataBySymbol = (data) =>
  data.reduce((acc, item) => {
    if (!acc[item.symbol]) {
      acc[item.symbol] = [];
    }
    acc[item.symbol].push(item);
    return acc;
  }, {});

const filterMktBulkTransaction = (data, count) => {
  const groupedData = groupDataBySymbol(data);
  const filteredSymbols = Object.entries(groupedData)
    .filter(([symbol, items]) => items.length >= count)
    .map(([symbol]) => symbol);

  return data.filter((item) => filteredSymbols.includes(item.symbol));
};

const loadLiveData = async (date) => {
  // $q.loading.show({});
  const formatedDate = date?.replaceAll("/", "-");

  try {
    const resBulkTransactionData =
      formatedDate === asOfLiveDate.value
        ? await BulkTransactionWithMarketBuySell()
        : await BulkTransactionWithMarketBuySellWithDate(formatedDate);

    bulkTransactionData.value = resBulkTransactionData.data.map((item) => ({
      ...item,
      cng_percentage: item.f_rate ? (item.cng_value / item.f_rate) * 100 : 0,
    }));
  } catch (error) {
    console.error("Error loading live data:", error);
  } finally {
    // $q.loading.hide();
  }
};

const computedBulkBuySellData = computed(() => {
  return bulkTransactionData.value.filter((item) => {
    const bulkBuy =
      filterBulkBuySell.value !== "bulk_tnx_with_buy" ||
      item.bulk_status === "BUY";

    const bulkSell =
      filterBulkBuySell.value !== "bulk_tnx_with_sell" ||
      item.bulk_status === "SELL";

    return bulkBuy && bulkSell;
  });
});

const computedBulkTransactionData = computed(() => {
  const sectorId = selectedSector.value.id;

  // Extract sector symbols and create a lookup set
  const sectorSymbols = allStocks.value
    ?.filter((i) => i.sector === sectorId)
    .map((stock) => stock.symbol);

  const moreThanFilteredData = filterMktBulkTransaction(
    computedBulkBuySellData.value,
    selectedMoreThan.value
  );

  const percentageRange =
    percentageChange.value === "All"
      ? { start: -Infinity, end: Infinity }
      : parseRange(percentageChange.value);

  //  finally filter main data
  return computedBulkBuySellData.value.filter((item) => {
    const isSectorMatch =
      sectorId === 0 || sectorSymbols.some((stock) => stock === item.symbol);

    const isMySignalMatch =
      !mySignals.value ||
      mySignalsStocks.value.some((stock) => stock === item.symbol);

    const moreThanOption = moreThanFilteredData.some(
      (filteredItem) => filteredItem.symbol === item.symbol
    );

    const isStrength =
      !isUserPlatinum.value ||
      strength.value === "All" ||
      strength.value === item.strength;

    const isPercentageChange =
      !isUserStaff.value ||
      percentageChange.value === "All" ||
      (item.cng_percentage >= percentageRange.start &&
        item.cng_percentage < percentageRange.end);

    return (
      isSectorMatch &&
      moreThanOption &&
      isStrength &&
      isPercentageChange &&
      isMySignalMatch
    );
  });
});

const checkUserStatus = () => {
  const packageStatus = store.state.packages.packageStatus;
  const whoAmI = store.state.accounts.whoAmI;

  mySignalsStocks.value = packageStatus.current_package.stocks;

  const platinumPackages = ["Platinum", "Platinum-1M", "Diamond+"];
  isUserPlatinum.value = platinumPackages.includes(
    packageStatus?.current_package?.package_name
  );

  isUserStaff.value = !!whoAmI?.is_staff;
  // isUserStaff.value = Boolean(whoAmI?.is_staff);

  isMarketOn.value = store.state.market.marketStatus;
};

const fetchInitialData = async () => {
  allStocks.value = store.state.core.allStocks || [];
  if (!allStocks.value.length) {
    await store.dispatch("core/getAllStocks");
    allStocks.value = store.state.core.allStocks;
  }

  const packageStatus = store.state.packages.packageStatus;
  const whoAmI = store.state.accounts.whoAmI;
  const isMarketOn = store.state.market.marketStatus;
  let asOfLive = store.state.market.asOfLive;
  asOfLiveDate.value = asOfLive?.split("T")[0]?.replaceAll("/", "-");

  if (!packageStatus?.current_package) {
    await store.dispatch("packages/getPackageStatus");
  }

  if (!whoAmI) {
    await store.dispatch("accounts/whoAmI");
  }

  if (!isMarketOn || !asOfLive) {
    await store.dispatch("market/marketStatusNew");
    asOfLive = store.state.market.asOfLive;
    asOfLiveDate.value = asOfLive?.split("T")[0]?.replaceAll("/", "-");
  }
  selectedDate.value = asOfLiveDate.value;

  // Load live data if selectedDate has a value
  if (selectedDate.value) {
    await loadLiveData(selectedDate.value);
  }

  checkUserStatus();
};

onMounted(async () => {
  await fetchInitialData();

  if ((isUserStaff.value || isUserPlatinum.value) && isMarketOn.value) {
    // Run loadLiveData at intervals for staff users
    interval = setInterval(async () => {
      await loadLiveData(selectedDate.value);
    }, 30000); // Adjust the interval as needed
  }
});

// Cleanup interval on component unmount
onUnmounted(() => {
  clearInterval(interval);
});

const columns = [
  {
    name: "date",
    label: "Date",
    field: "date",
    format: (val, row) => {
      return convertDate(val);
    },
    sortable: true,
    align: "left",
  },
  {
    name: "symbol",
    label: "Symbol",
    field: "symbol",
    sortable: true,
    align: "center",
  },
  {
    name: "bulk_status",
    label: "Status",
    field: "bulk_status",
    format: (val, row) => {
      return val;
    },
    sortable: true,
    align: "center",
  },
  {
    name: "buyer",
    label: "Buyer",
    field: "buyer",
    format: (val, row) => {
      return val ? val : "-";
    },
    sortable: true,
    align: "center",
  },
  {
    name: "seller",
    label: "Seller",
    field: "seller",
    format: (val, row) => {
      return val ? val : "-";
    },
    sortable: true,
    align: "center",
  },

  {
    name: "cnt",
    label: "No. of Tnx",
    field: "cnt",
    sortable: true,
    align: "center",
  },

  {
    name: "cumm_quantity",
    label: "Cumm Qnt",
    field: "cumm_quantity",
    sortable: true,
    align: "center",
  },
  {
    name: "rate",
    label: "Rate",
    field: "rate",
    sortable: true,
    format: (val, row) => {
      return val?.toFixed(2);
    },
    align: "center",
  },
  {
    name: "amt",
    label: "Amt",
    field: "amt",
    format: (val, row) => {
      return amountConversion(row.cumm_quantity * row.rate);
    },
    sortable: true,
    align: "center",
  },
];

const columnsIsStaff = [
  ...columns,
  {
    name: "strength",
    label: "Strength",
    field: "strength",
    format: (val, row) => {
      return val;
    },
    sortable: true,
    align: "center",
  },
  {
    name: "f_rate",
    label: "From Rate",
    field: "f_rate",
    format: (val, row) => {
      return val?.toFixed(2);
    },
    sortable: true,
    align: "center",
  },
  {
    name: "t_rate",
    label: "To Rate",
    field: "t_rate",
    format: (val, row) => {
      return val?.toFixed(2);
    },
    sortable: true,
    align: "center",
  },
  {
    name: "cng_value",
    label: "CH. Value",
    field: "cng_value",
    format: (val, row) => {
      return val?.toFixed(2);
    },
    sortable: true,
    align: "center",
  },
  {
    name: "cng_percentage",
    label: "CH %. ",
    field: "cng_percentage",
    format: (val, row) => {
      return val?.toFixed(2);
    },
    sortable: true,
    align: "center",
  },
];

const computedColumns = computed(() => {
  return isUserStaff.value ? columnsIsStaff : columns;
});

const onClickSymbolEmit = (symbol) => {
  emit("chartSymbol", symbol);
};

const pagination = {
  sortBy: "date",
  rowsPerPage: 0,
  descending: true,
};

const convertDateAsOf = (date) => moment(date).format("YYYY-MM-DD");
const convertDate = (date) => moment(date).format("MM-DD, hh:mm A");
</script>
